import { CSS } from '@grupoboticario/flora-react'

export const skeletonTableCss: CSS = {
  display: 'inline-table',
  width: '100%',
  opacity: '0.6'
}

export const skeletonColumnsCss: CSS = {
  width: '100%'
}

export const skeletonRowCss: CSS = {
  width: '100%',
  display: 'flex !important',
  borderRadius: '$small'
}

export const skeletonCellCss = (minWidth: number | string): CSS => ({
  minWidth,
  width: '100%',
  paddingLeft: '16px'
})
